import "slick-carousel"
const $ = require( "jquery" )

class Carousel {
  constructor() {
    this.defineVariables()
    this.init()
  }

  defineVariables () {
    this.$slider_base_config = {
      dots: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 3000,
      prevArrow: "",
      nextArrow: "",
      slidesToShow: 9,
      cssEase: 'linear',
      pauseOnHover: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: false,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 8,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: false,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: false,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 4,
          }
        },
      ]
    }
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.initSlider()
    this.initCSSCarousel()
  }

  cacheDOM () {
    this.$logo_slider = $( "[id^=logo_slider_]" )
    this.$two_row_logo_slider = $( "[id^=row_2_logo_slider_]" )
    this.$testimonial_cards = $( ".testimonial-cards" )
  }

  bindEvents () {

  }

  initSlider () {
    this.$logo_slider.slick( this.$slider_base_config )
    this.$two_row_logo_slider.slick( { ...this.$slider_base_config, ...{ rows: 2 } } )
    $( '.testimonial-cards' ).slick( {
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: true,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 2,
            centerMode: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 1,
            centerMode: false,
            prevArrow: "",
            nextArrow: "",
          }
        }

      ]
    } )
  }

  initCSSCarousel () {
    $( '.css-carousel .carousel-track' ).slick( {
      ...this.$slider_base_config,
      variableWidth: true,
      slidesToShow: 1,
      responsive: []
    } )
  }
}

new Carousel()
